export default __webpack_public_path__ + "static/media/Antanas-Gouga.01d1e4bb.png";